(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.Reports",
                {
                    url: "/Reports",
                    component: "reports",
                    PageTitle: "Reports",
                    requiredPermissions: "Reports:NewBusiness"
                });
        }
    ]);

    app.component("reports",
        {
            templateUrl: "App/Tools/Reports/Reports.html",
            controller: "reportsController",
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    app.controller("reportsController", ["$scope", "reportsApi", "$q", "_", "policyStages", "permissionService", "figToaster", "amplitudeService", "featureToggleService", function ($scope, reportsApi, $q, _, policyStages, permissionService, figToaster, amplitudeService, featureToggleService) {
        var $ctrl = this;
        window.o = this;
        var downloadIncrement = 0;
        $ctrl.user = $ctrl.onBehalfOfUser || $ctrl.user;
        $ctrl.logEvent = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        ng.extend($ctrl,
            {
                UI: {
                    Active: false,
                    ReportTypeId: 1,
                    LineOfBusinessId: 1,
                    width: "6px",
                    PolicyLoading: false,
                    AllSubAgents: false,
                    ShowPolicyDetails: false,
                    uploadedFiles: [],
                    ShowRequirements: false,
                    orderByField: featureToggleService.checkEnv() !== "prod" ? "ActionNeeded" : "LastName",
                    reverseSort: featureToggleService.checkEnv() !== "prod" ? true : false,
                    ShowAgentCommissions: false,
                    StartDate: new Date(new Date().getFullYear(), 0, 1),
                    EndDate: new Date(),
                    isUploading: false,
                    animateBottom: false,
                    animateTop: false,
                    showNotes: null,
                },
                PolicyStages: policyStages,
                LinesOfBusiness: [
                    { LineOfBusinessId: 1, LineOfBusiness: "Annuity" },
                    { LineOfBusinessId: 2, LineOfBusiness: "Life" },
                    { LineOfBusinessId: 3, LineOfBusiness: "Long Term Care" }
                ],
                AccountValues: [
                    { Key: "Required Minimum Distribution Basis Value", Value: "RMD Basis Value" },
                    { Key: "Initial Deposit Amount", Value: "Initial Deposit Amount" },
                    { Key: "Total Deposit", Value: "Total Deposit" },
                    { Key: "Cash Value Amount", Value: "Cash Value Amount" },
                    { Key: "Surrender Value", Value: "Surrender Value" },
                    { Key: "Net Surrender Value", Value: "Net Surrender Value" },
                    { Key: "Cost Basis", Value: "Cost Basis" },
                    { Key: "Total Withdrawal", Value: "Total Withdrawal" },
                    { Key: "Net Death Benefit", Value: "Net Death Benefit" },
                    { Key: "Gross Death Benefit", Value: "Gross Death Benefit" }
                ],
                Dates: [
                    { Key: "Issue Effective Date", Value: "Issue Effective Date" },
                    { Key: "Maturity Date", Value: "Maturity Date" }
                ],
                buildReportTypes: buildReportTypes,
                exportPolicyReport: exportPolicyReport,
                evalSortClasses: evalSortClasses,
                toggleSort: toggleSort,
                getData: getData,
                getSubAgents: getSubAgents,
                getAllRequirementNotes: getAllRequirementNotes,
                getAdditionalData: getAdditionalData,
                getSubAgentPolicyData: getSubAgentPolicyData,
                selectAllSubAgents: selectAllSubAgents,
                getPolicyDetail: getPolicyDetail,
                getPoliciesRequirements: getPoliciesRequirements,
                reorderRequirements: reorderRequirements,
                removeFromUploadedFiles: removeFromUploadedFiles,
                sendFilesToArc: sendFilesToArc,
                loadAccountValues: loadAccountValues,
                environment: featureToggleService.checkEnv(),
                isAgentSubmitted: isAgentSubmitted
            });

        var loading;
        $ctrl.checkMe = false;

        function buildReportTypes() {
            var reports = [
                { ReportTypeId: 1, ReportType: "Pending" },
                { ReportTypeId: 2, ReportType: "Inforce" },
                { ReportTypeId: 3, ReportType: "Inforce / Pending" },
                { ReportTypeId: 4, ReportType: "Paid" },
                { ReportTypeId: 5, ReportType: "Informal" }
            ];

            if (!permissionService.hasOnePermission("Reports:PaidBusiness")) {

                reports = _.filter(reports, function (item) {
                    return item.ReportTypeId !== 4;
                });
            }

            $ctrl.reportType = reports;
        }

        function evalSortClasses(name) {
            var obj = {
                "fa-sort": $ctrl.UI.orderByField !== name,
                "fa-caret-down": $ctrl.UI.orderByField === name && $ctrl.UI.reverseSort,
                "fa-caret-up": $ctrl.UI.orderByField === name && !$ctrl.UI.reverseSort
            };

            return obj;
        }

        function toggleSort(name) {
            if ($ctrl.UI.orderByField === name) {
                $ctrl.UI.reverseSort = !$ctrl.UI.reverseSort;
            } else {
                $ctrl.UI.orderByField = name;
            }
        }

        function removeFromUploadedFiles(index) {
            $ctrl.UI.uploadedFiles = _.filter($ctrl.UI.uploadedFiles, function (f) {
                return $ctrl.UI.uploadedFiles.indexOf(f) !== index;
            });
        }

        function sendFilesToArc() {
            var formData = new FormData();
            $ctrl.UI.uploadedFiles.forEach(function (file) {
                formData.append(file.notes, file, file.name);
            });
            var message = "", toastClass = "";
            reportsApi.postPolicyFiles($ctrl.SelectedPolicyDetail.PolicyDetail.PolicyGuid, formData).then(function (fileCount) {
                message = fileCount === 1 ? "1 file uploaded successfully!" : fileCount + " files uploaded successfully!";
                toastClass = "is-success";
            })
                .catch(function (error) {
                    message = "Error: something went wrong";
                    toastClass = "is-error";
                })
                .finally(function () {
                    if (toastClass === "is-success") $ctrl.UI.uploadedFiles = [];
                    $ctrl.UI.isUploading = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function getData() {

            buildReportTypes();

            $ctrl.UI.PolicyLoading = true;

            if (!permissionService.getOnBehalfOfUserId() || permissionService.hasOnePermission("AgentCommissions:View")) {
                $ctrl.UI.ShowAgentCommissions = true;
            }
            else
                $ctrl.UI.ShowAgentCommissions = false;

            var lob = _.find($ctrl.LinesOfBusiness,
                function (row) { return row.LineOfBusinessId === $ctrl.UI.LineOfBusinessId; }).LineOfBusiness;

            var reportTypeId = $ctrl.UI.ReportTypeId;
            loading = lob;

            reportsApi.getPendingPolicies(lob).then(function (data) {
                if ($ctrl.UI.ReportTypeId === reportTypeId && loading === lob) {
                    $ctrl.UI.PolicyLoading = false;
                    $ctrl.PolicyData = data;
                    $ctrl.showCurrentValue = _.filter(data, function (row) { return row.CurrentValue > 0 }).length;
                }
            });
        }

        function loadAccountValues() {
            reportsApi.getPolicyAccountValues($ctrl.SelectedPolicyDetail.PolicyGuid).then(function (data) {
                $ctrl.accountValues = data;
                $ctrl.accountValues.lastUpdatedDate = _.sortBy(data.Values.Values, function (row) { return row.Date }, Math).reverse()[0].Date;
                $ctrl.accountValues.totalContractValue = _.filter(data.Values.Values, function (row) { return row.Type === "Total Contract Amount" })[0].Value;
            })
        }

        function getSubAgents() {
            $ctrl.UI.LoadingSubAgents = true;
            reportsApi.getSubAgents().then(function (data) {
                $ctrl.UI.LoadingSubAgents = false;
                $ctrl.SubAgents = data;
            });
        }

        function getPoliciesRequirementsBatch(policies, index) {
            var batchSize = 50;
            var policyArray = [];
            if (index + batchSize >= policies.length) {
                for (var i = index; i < policies.length; i++) policyArray.push(policies[i]);
                var policyGuids = _.map(policyArray, "PolicyGuid").join(",");
            } 
        }

        function getPoliciesRequirements() {
            $ctrl.UI.PolicyLoading = true;
            $ctrl.UI.SearchTerm = "";
            if ($ctrl.UI.ShowRequirements) {
                amplitudeService.logClickEvent("Requirements View");

                var policies = _.filter($ctrl.PolicyData, function (row) { return !row.IsVariable });
                
                var variablePolicyGuids = _.map(_.filter($ctrl.PolicyData, function (row) { return row.IsVariable }), "PolicyGuid").join(",");
                var promises = [];

                var batchSize = 50;
                var batches = policies.length / batchSize;
                Math.ceil(batches);
                for (var i = 0; i < batches; i++) {
                    var policyBatch = [];
                    var startingIndex = i * batchSize;
                    for (var x = startingIndex; x < startingIndex + batchSize; x++) {
                        if (policies[x]) policyBatch.push(policies[x]);
                    }
                    var policyGuids = _.map(policyBatch, "PolicyGuid").join(",");
                    promises.push(reportsApi.getPoliciesRequirements(policyGuids).then(function (policies) {
                        return policies;
                    }));
                }

                if (variablePolicyGuids.length) {
                    promises.push(reportsApi.getVariablePoliciesRequirements(variablePolicyGuids).then(function (variablePolicies) {
                    return variablePolicies;
                }));
                }
                $q.all(promises).then(function (p) {
                    var requirements = [];
                    for (var i = 0; i < p.length; i++) {
                        requirements = requirements.concat(p[i]);
                    }
                    $ctrl.policiesRequirements = requirements;
                    reorderRequirements();
                    $ctrl.UI.PolicyLoading = false;
                });
            }
            else {
                $ctrl.UI.PolicyLoading = false;
            }
        }

        function reorderRequirements() {
            if ($ctrl.UI.ShowRequirements) {
                $ctrl.policiesRequirements = $ctrl.policiesRequirements.sort(
                    function (a, b) {
                        if (a[$ctrl.UI.orderByField] === b[$ctrl.UI.orderByField]) {
                            return a.PolicyNumber - b.PolicyNumber;
                        }
                        return a[$ctrl.UI.orderByField] > b[$ctrl.UI.orderByField] ? 1 : -1;
                    });
                if ($ctrl.UI.reverseSort === true) $ctrl.policiesRequirements = $ctrl.policiesRequirements.reverse();
                var isOdd = true;
                for (var i = 0; i < $ctrl.policiesRequirements.length; i++) {
                    $ctrl.policiesRequirements[i].isOdd = isOdd;
                    if (i < $ctrl.policiesRequirements.length - 1 && $ctrl.policiesRequirements[i].PolicyNumber !== $ctrl.policiesRequirements[i + 1].PolicyNumber) isOdd = !isOdd;
                }
            }
        }

        function getAllRequirementNotes(taskId) {
            var task = _.find($ctrl.SelectedPolicyDetail.TaskInformation, function (row) { return row.TaskID === taskId });
            if (!task.showNote) {
                !$ctrl.SelectedPolicyDetail.PolicyDetail.IsVariable ?
                reportsApi.getPolicyNotes(taskId).then(function (notes) {
                    task.notes = notes;
                    $ctrl.isAgentSubmitted(notes);
                }) : reportsApi.getVariablePolicyNotes(taskId).then(function (notes) {
                    task.notes = notes;
                    $ctrl.isAgentSubmitted(notes);
                });
            }
            task.showNote = !task.showNote;
        }

        function getAdditionalData() {
            var lob = _.find($ctrl.LinesOfBusiness,
                function (row) { return row.LineOfBusinessId === $ctrl.UI.LineOfBusinessId; }).LineOfBusiness;
            loading = lob;

            $ctrl.UI.PolicyLoading = true;
            $ctrl.UI.SearchTerm = "";
            if (!$ctrl.UI.ShowSubAgents) {
                var promise = ng.noop;

                var reportTypeId = $ctrl.UI.ReportTypeId;

                switch ($ctrl.UI.ReportTypeId) {
                    case 1:
                        promise = reportsApi.getPendingPolicies(lob);
                        break;
                    case 2:
                        promise = reportsApi.getInforcePolicies(lob);
                        break;
                    case 3:
                        promise = reportsApi.getAgentPolicies(lob);
                        break;
                    case 4:
                        promise = reportsApi.getPaidPolicies($ctrl.UI.StartDate.toUTCString(), $ctrl.UI.EndDate.toUTCString(), lob);
                        break;
                    case 5:
                        promise = reportsApi.getInformalPolicies();
                        break;
                }

                promise.then(function (data) {
                    if ($ctrl.UI.ReportTypeId === reportTypeId && loading === lob) {
                        $ctrl.UI.PolicyLoading = false;
                        $ctrl.PolicyData = data;

                        $ctrl.showCurrentValue = _.filter(data, function (row) { return row.CurrentValue > 0 }).length;
                    }
                }), function () {
                    $ctrl.UI.PolicyLoading = false;
                    console.log("An error occurred loading the report data");
                };
            } else {
                $ctrl.getSubAgentPolicyData();
            }
        }

        function getSubAgentPolicyData() {
            $ctrl.UI.PolicyLoading = true;

            var agentGuids =
                _.map(_.filter($ctrl.SubAgents, function (ag) { return ag.Selected === true; }), "ChildAgentGuid");

            var lob = _.find($ctrl.LinesOfBusiness,
                function (row) { return row.LineOfBusinessId === $ctrl.UI.LineOfBusinessId; }).LineOfBusiness;

            loading = "SubAgent" + lob;
            var reportTypeId = $ctrl.UI.ReportTypeId;

            var promises = [];
            var data = [];

            var concat = function (response) {
                return data = _.union(data, response);
            };

            var agentIds = "";
            for (var i = 0; i < agentGuids.length; i++) {
                agentIds += agentGuids[i];
                if (i < agentGuids.length - 1)
                    agentIds += ",";
            }

            if (agentIds) {
                switch ($ctrl.UI.ReportTypeId) {
                    case 1:
                        promises.push(reportsApi.getAgentsPendingPolicies(agentIds, lob).then(concat));
                        break;
                    case 2:
                        promises.push(reportsApi.getAgentsInforcePolicies(agentIds, lob).then(concat));
                        break;
                    case 3:
                        promises.push(reportsApi.getAgentsPolicies(agentIds, lob).then(concat));
                        break;
                    case 4:
                        promises.push(reportsApi.getAgentsPaidPolicies(agentIds,
                            lob,
                            $ctrl.UI.StartDate.toUTCString(),
                            $ctrl.UI.EndDate.toUTCString()).then(concat));
                        break;
                    case 5:
                        promises.push(reportsApi.getAgentsInformalPolicies(agentIds).then(concat));
                        break;
                }
            }

            if (!promises.length || $ctrl.UI.UserSelected) {
                switch ($ctrl.UI.ReportTypeId) {
                    case 1:
                        promises.push(reportsApi.getPendingPolicies(lob).then(concat));
                        break;
                    case 2:
                        promises.push(reportsApi.getInforcePolicies(lob).then(concat));
                        break;
                    case 3:
                        promises.push(reportsApi.getAgentPolicies(lob).then(concat));
                        break;
                    case 4:
                        promises.push(reportsApi.getPaidPolicies($ctrl.UI.StartDate.toUTCString(),
                            $ctrl.UI.EndDate.toUTCString(), lob).then(concat));
                        break;
                    case 5:
                        promises.push(reportsApi.getInformalPolicies().then(concat));
                        break;
                }
            }

            $q.all(promises).then(function () {
                if ($ctrl.UI.ReportTypeId === reportTypeId && loading === "SubAgent" + lob) {
                    $ctrl.UI.PolicyLoading = false;
                    $ctrl.PolicyData = data;
                }
            });
        }

        function selectAllSubAgents() {
            if ($ctrl.UI.AllSubAgents === true) {
                ng.forEach($ctrl.SubAgents,
                    function (agent) {
                        agent.Selected = true;
                    });
                $ctrl.UI.UserSelected = true;
                $ctrl.getSubAgentPolicyData();
            }
            if ($ctrl.UI.AllSubAgents === false) {
                ng.forEach($ctrl.SubAgents, function (agent) {
                    agent.Selected = false;
                });
                $ctrl.UI.UserSelected = false;
                $ctrl.getAdditionalData();
            }
        }

        function getPolicyDetail(policy) {
            amplitudeService.logClickEvent("Policy Detail");
            var isVariable = policy.IsVariable;
            var promise = $ctrl.UI.ReportTypeId === 5
                ? reportsApi.getInformalDetail(policy.InformalGuid)
                : isVariable ? reportsApi.getVariablePolicyDetail(policy.PolicyGuid) : reportsApi.getPolicyDetail(policy.PolicyGuid);

            promise.then(function (data) {
                $ctrl.UI.ShowPolicyDetails = true;
                $ctrl.SelectedPolicyDetail = data;
                $ctrl.SelectedPolicyDetail.PolicyDetail = policy;
            });
        }

        function exportPolicyReport() {
            $ctrl.UI.Exporting = true;
            var lob = _.find($ctrl.LinesOfBusiness,
                function (row) { return row.LineOfBusinessId === $ctrl.UI.LineOfBusinessId; }).LineOfBusiness;
            var stage = "";
            switch ($ctrl.UI.ReportTypeId) {
                case 1:
                    stage = "Pending";
                    break;
                case 2:
                    stage = "Inforce";
                    break;
                case 3:
                    stage = "All";
                    break;
                case 4:
                    stage = "Paid";
                    break;
                case 5:
                    stage = "Informal";
                    break;
            }
            if ($ctrl.UI.ShowRequirements) {
                return reportsApi.ExportRequirementForLobReport($ctrl.policiesRequirements, stage, lob).then(function (data) {
                    $ctrl.UI.Exporting = false;

                    downloadFile(data);
                });
            }
            else {
                var agentGuids =
                    _.map(_.filter($ctrl.SubAgents, function (ag) { return ag.Selected === true; }), "ChildAgentGuid");

                var agentIds = "";
                for (var i = 0; i < agentGuids.length; i++) {
                    agentIds += agentGuids[i];
                    if (i < agentGuids.length - 1)
                        agentIds += ",";
                }
                var model = { AgentIds: agentIds };
                if (stage === "Paid") {
                    model.StartDate = $ctrl.UI.StartDate;
                    model.EndDate = $ctrl.UI.EndDate;
                }

                if (!agentGuids || !agentGuids.length || $ctrl.UI.UserSelected) {
                    model.IncludeUser = true;
                }

                model.CanSeeAgentCommissions = $ctrl.UI.ShowAgentCommissions;

                return reportsApi.exportAgentsPolicies(model, stage).then(function (data) {
                    $ctrl.UI.Exporting = false;

                    downloadFile(data);
                });
            }
        }

        function isAgentSubmitted(note) {
            var figAuthUserId = $ctrl.user.Id;
            _.forEach(note, function (n) {
                n.IsUser = n.FigAuthUserId === null || n.FigAuthUserId !== figAuthUserId ? false : true;
            });
        }

        $ctrl.logEvent = function (clickTarget) {
            amplitudeService.logClickEvent(clickTarget);
        };

        function downloadFile(data) {
            var f = document.createElement("a");
            f.id = "tmpDownload-" + ++downloadIncrement;
            document.body.appendChild(f);
            f.style = "display: none";

            var fUrl = window.URL.createObjectURL(data);
            f.href = fUrl;
            f.download = $ctrl.UI.ShowRequirements ? "RequirementData.xlsx" : "PolicyData.xlsx";
            f.click();

            setTimeout(function () {
                var el = document.getElementById(f.id);
                document.body.removeChild(el);
                window.URL.revokeObjectURL(fUrl);
            },
                100);
        }

        $ctrl.$onInit = function () {
            $ctrl.getData();          
        };
    }]);

    //app.factory('darkThemeService', [function darkThemeService() {
    //    var service = {
    //        getCookie: getCookie,
    //        setCookie: setCookie
    //    };

    //    return service;

    //    function getCookie() {

    //    }

    //    function setCookie(value) {
    //        localStorage.setItem('darkTheme', value);
    //        if (value === true)
    //            return value = true;
    //    }
    //}]);

})(window.app, window.angular); // jshint ignore:line